package de.ohhhmhhh.backend.models.model.revocation

import kotlinx.serialization.Serializable

@Serializable
enum class RevocationContractTypeEntity {
    SHOP_ORDER, SHOP_ITEMS, VOUCHER, SUBSCRIPTION;
}